import React from 'react';

import { ErrorContainer } from './styled';

const FilterOptionsError = () => (
  <ErrorContainer>An error occurred retrieving the filtering options. Please try again later.</ErrorContainer>
);

export default FilterOptionsError;
